(($) => {
  const el = {
    shipping_methods: ".woocommerce-shipping-methods li",
  };

  // eslint-disable-next-line no-unused-vars
  $(document.body).on("updated_checkout", (e) => {
    if ($(el.shipping_methods).length < 1) return false;

    $(el.shipping_methods).each((index, el) => {
      const $shipping_method_radio_checked = $(el).find(
        ".shipping_method:checked"
      );

      if ($shipping_method_radio_checked.length < 1) {
        $(el).remove();
      }
    });
  });
  // eslint-disable-next-line no-undef
})(jQuery);
